import { createSelector } from "reselect";

export const createConfigReceiverCodeSelector = createSelector(
    state => state.configManager.createEditConfig.initialConfig.receiver_code,
    state => state
);

export const createEditConfigSelector = createSelector(
    state => state.configManager.createEditConfig,
    state => state
);

export const normalizersSelector = createSelector(
    state => state.configManager.createEditConfig.normalizers,
    state => state
);

export const blockSelectorDialogSelector = createSelector(
    state => state.configManager.createEditConfig.templateBlockSelectorDialog,
    state => state
);

export const dataSelectorDialogSelector = createSelector(
    state => state.configManager.createEditConfig.templateDataSelectorsDialog,
    state => state
);

export const dataNormalizersDialogSelector = createSelector(
    state => state.configManager.createEditConfig.templateDataNormalizersDialog,
    state => state
);

export const configMessageDialogSelector = createSelector(
    state => state.configManager.createEditConfig.commentDialog,
    state => state
);
